export default {
  close: {
    en: 'close',
  },
  myQueue: {
    en: 'My queue',
  },
  openMyQueue: {
    en: 'Open my queue',
  },
}
